export default "__VITE_ASSET__D5Bf8Kfc__"